import React from "react";
import { HelpSectionHeaderProps } from "../interfaces";
import "./HelpSectionHeader.scss";

const HelpSectionHeader: React.FC<HelpSectionHeaderProps> = ({ eyebrow, title, text }) => (
  <div className="help-section__header">
    {eyebrow && <p className="help-label">{eyebrow}</p>}
    <h2>{title}</h2>
    <p>{text}</p>
  </div>
);

export default HelpSectionHeader;
